import { colors } from '@material-ui/core';

const white = '#FFFFFF';
export const colorPalette = [
  '#4e5775',
  '#20358c',
  '#415cc6',
  '#dce4fb',
  '#ccf1cd',
  '#0c4e8c',
  '#f44336',
  '#fbb541'
];

export default {
  primary: {
    contrastText: white,
    main: colorPalette[1]
  },
  secondary: {
    contrastText: white,
    main: colorPalette[1]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: '#1e1e21',
    secondary: '#888a91',
    link: colorPalette[1]
  },
  link: colorPalette[1],
  icon: colors.blueGrey[600],
  background: {
    default: '#f5f9ff',
    paper: white
  },
  colorPalette,
  divider: colors.grey[200]
};
